<script>
/**
 * A component to display form validation errors. Checks :errors for a value called :name and if it exists, the
 * error value is rendered.
 */
export default {
  props: {
    errors: {
      type: Object,
      default() {
        return {}
      }
    },

    /**
     * The name of the error we are looking for in the error bag. If you have a tag <input name="dog" /> then :name
     * probably should be "dog"
     */
    name: {
      type: String,
      required: true
    }
  },

  computed: {
    /**
     * Returns the error message if it exists
     */
    theError() {
      return this?.errors?.[this.name] ? this.errors[this.name] : null
    },

    /**
     * Returns true if the error we are checking for exists
     * @returns {boolean}
     */
    hasError() {
      return !!this?.theError
    }
  }
}
</script>

<template>
  <div
    v-if="hasError"
    class="text-red-600"
  >
    {{ theError }}
  </div>
</template>
